import CampaignTrendingPanel from './campaignTrendingPanel.container';

export default CampaignTrendingPanel;